import styled from "styled-components";
import searchIcon from "../../../assets/images/icons/search-filled-icon.svg";
import { COLORS } from "../../../assets/utils/enums/colors";
import { boxShadow } from "../../components-style";
import { TextBody } from "../../typography";
import Dropdown from "../../ui/dropdown";
import { useState } from "react";
import { panelItems } from "../../../assets/utils/data/panel-items";
import { langs } from "../../../assets/utils/data/langs";
import { useLocation } from "react-router-dom";
import { DropdownTypeEnum } from "../../../assets/utils/enums/table";

export default function AppHeader() {
  const location = useLocation();
  const [searchValue, setSearchValue] = useState<string>(
    location.pathname === "/main" ? panelItems[0].name : panelItems.find(x => location.pathname.includes(x.id))?.name!
  );
  const [lang, setLang] = useState<string>(langs[0].id);
  return (
    <HeaderStyle>
      <SearchStyle>
        <img src={searchIcon} alt="search-icon" />
        <Dropdown
          checkedValue={searchValue}
          setChecked={setSearchValue}
          type={DropdownTypeEnum.PANEL_ITEMS}
        />
        <input placeholder="Пошук..." />
      </SearchStyle>
      <span data-type="profile-span">
        <Dropdown checkedValue={lang} setChecked={setLang} type={DropdownTypeEnum.LANGS} />

        <Dropdown checkedValue={""} setChecked={() => { }} type={DropdownTypeEnum.PROFILE} />


      </span>
    </HeaderStyle>
  );
}

const HeaderStyle = styled.header`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: 24px;
  padding: 12px 28px;
  ${boxShadow("rgba(0, 0, 0, 0.15)")}
  background-color: ${COLORS.white};

  span {
    &[data-type="profile-span"] {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
`;

const SearchStyle = styled.div`
  border-radius: 28px;
  background-color: ${COLORS["light-gray"]};
  padding: 8px 24px;
  display: flex;
  align-items: center;
  gap: 16px;

  img {
    width: 24px;
    height: 24px;
  }

  input {
    flex-grow: 1;
    background-color: transparent;
    border: none;
    outline: none;
    caret-color: ${COLORS.secondary1};
    ${TextBody.componentStyle.rules.join("")}
    color: ${COLORS.secondary1};

    &::placeholder {
      color: ${COLORS["bg-text-color"]};
    }
  }
  flex-grow: 1;
`;
